/**
 * Developed By Aritra Basak, EY
 * (Latest)
 */
import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import { Stepper } from "@material-ui/core";
import { Step } from "@material-ui/core";
import { StepLabel } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { MenuItem } from "@material-ui/core";
import { Select } from "@material-ui/core";
import { InputLabel } from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";
import { Paper } from "@material-ui/core";
import { Modal } from "@material-ui/core";
import { Fade } from "@material-ui/core";
import { Backdrop } from "@material-ui/core";
import { Divider } from "@mui/material";
import { Typography } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Table } from "@material-ui/core";
import { TableBody } from "@material-ui/core";
import { TableCell } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { TableRow } from "@material-ui/core";
import { CreateTwoTone, Visibility, VisibilityOff } from "@material-ui/icons";
import InfoTwoTone from "@material-ui/icons/InfoTwoTone";
import Tooltip from "@material-ui/core/Tooltip";
import { asyncPost } from "../../../common/utils";
import {
  RESEND_OTP_TIMEOUT,
  RESEND_OTP_CHANCE,
} from "../../../constants/dataconstants";
import { URI } from "../../../constants/index";
import "../../../assets/styles/V3.css";
import AadhaarInput from "../AadhaarInput";

const steps = [
  "Step 1",
  "Step 2",
  "Step 3",
  "Step 4",
  "Step 5",
  "Step 6",
  "Step 7",
];

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  stepper: {
    "& .MuiStepIcon-active": { color: global.secondaryColour },
    "& .MuiStepIcon-completed": { color: global.secondaryColour },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#ccc" },
  },

  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(10),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    padding: theme.spacing(5),
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px solid #000",
  },
}));

function GenerateAbhaV3() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [benificieryName, setBenificieryName] = React.useState("");
  const [healtCareWorkerName, setHealthCareWorkerName] = React.useState("");
  const [aadhaarId, setAadhaarId] = React.useState("");
  const [aadhaarOtp, setAadhaarOtp] = React.useState("");
  const [txnId, setTxnId] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [mobileOtp, setMobileOtp] = React.useState("");
  const [patientName, setPatientName] = React.useState("");
  const [healthIdRes, setHealthIdRes] = React.useState("");
  const [healthIdNoRes, setHealthIdNoRes] = React.useState("");
  const [isNewProfile, setIsNewProfile] = React.useState("");
  const [mobileRes, setMobileRes] = React.useState();
  const [dobRes, setDobRes] = React.useState();
  const [genderRes, setGenderRes] = React.useState();
  const [kycPhotoRes, setKycPhotoRes] = React.useState();
  const [profileImageRes, setProfileImageRes] = React.useState();
  const [xToken, setXToken] = React.useState("");
  const [modalState, setModalState] = React.useState(false);
  const [modalData, setModalData] = React.useState("");
  const [modalError, setModalError] = React.useState(0);
  const [showLoader, setShowLoader] = React.useState(false);
  const [resendOtpChance, setResendOtpChance] = React.useState(0);
  const [buttonText, setButtonText] = React.useState("RESEND OTP");
  const [selectedAddress, setSelectedAddress] = React.useState("");
  const [abhaAddressList, setAbhaAddressList] = React.useState({});
  const [addressRes, setAddressRes] = React.useState("");
  const [districtCodeRes, setDistrictCodeRes] = React.useState("");
  const [stateCodeRes, setStateCodeRes] = React.useState("");
  const [stateName, setStateName] = React.useState("");
  const [districtName, setDistrictName] = React.useState("");
  const [pinCodeRes, setPinCodeRes] = React.useState("");
  const [intervalId, setIntervalId] = React.useState(null);

  const modalWidth = Math.min(500, Math.max(300, modalData.length * 6)) + "px";

  useEffect(() => {
    if (global.benificiaryName !== "" || global.benificiaryName !== null)
      setBenificieryName(global.benificiaryName);
    if (global.user !== null || global.user !== "")
      setHealthCareWorkerName(global.user);
  }, []);

  //To send OTP to the mobile number registered with the given Aadhaar Number for New Abha Registration.
  const handleGetOtp = async (value) => {
    if (aadhaarId.trim() === null) {
      setAadhaarId(value);
    }
    clearInterval(intervalId); //Clearing the resendOTP button timer interval at the start, so that if someone exit the process before confirming the OTP and restart the process, correct OTP will be displayed.
    if (value.trim() === "") {
      setModalData("Kindly enter your Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    if (value.trim().length !== 12) {
      setModalData("Kindly enter a valid Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    if (value.trim().match(/^[0-9]+$/) === null) {
      setModalData("Kindly enter a valid Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    const __oo = { aadhaar: value };
    setShowLoader(true);
    const res = await asyncPost(
      URI.v3sendAadhaarOtp,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      //debugger;
      setTxnId(res.resObject.txnId);
      console.log(res);
      handleNext();
      setModalData(res.resObject.message);
      handleModalOpen();
      resendOtpButtontext();
      setShowLoader(false);
      setMobile(global.mobileNumber);
    } else {
      setShowLoader(false);
      //debugger;
      console.log("resObject " + JSON.stringify(res.resObject));
      if (String(JSON.stringify(res.resObject)).includes("Invalid LoginId")) {
        setModalData(
          res.resObject.loginId + ", Kindly enter a valid Aadhaar Number."
        );
        handleModalOpen(1);
        return false;
      } else if (
        res.resObject.hasOwnProperty("error") &&
        (res.resObject.error.code === "ABDM-1204" ||
          String(res.resObject.error.message).includes(
            "Invalid Aadhaar Number"
          ))
      ) {
        setModalData(
          "Invalid Aadhaar Number, Kindly enter valid Aadhaar Number."
        );
        handleModalOpen(1);
        return false;
      } else if (
        res.resObject.hasOwnProperty("error") &&
        res.resObject.error.code.hasOwnProperty("message")
      ) {
        setModalData(res.resObject.error.code.message);
        handleModalOpen(1);
        return false;
      } else {
        setModalData(res.resObject.error.message);
        handleModalOpen(1);
        return false;
      }
    }
  };

  //To resend OTP to the aadhar registered mobile number
  const resendAadhaarOtp = async () => {
    setShowLoader(true);
    //To show the remaining count as soon as the button is clicked.
    var count = parseInt(resendOtpChance);
    count++;
    setResendOtpChance(count);
    const res = await asyncPost(
      URI.v3sendAadhaarOtp,
      { aadhaar: aadhaarId },
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      //debugger;
      setTxnId(res.resObject.txnId);
      setModalData(res.resObject.message);
      handleModalOpen();
      resendOtpButtontext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        res.resObject.hasOwnProperty("error") &&
        res.resObject.error.hasOwnProperty("message")
      ) {
        setModalData(res.resObject.error.message);
        handleModalOpen(1);
        return false;
      } else if (
        String(res.responseMessage).includes("Failure: Could not send the OTP")
      ) {
        setModalData(
          "Message from ABDM : Cannot send OTP now. Please try again after sometime."
        );
        handleModalOpen(1);
        return false;
      }
    }
  };

  //To verify the OTP sent while using the Aadhaar Number for new Abha registration
  const verifyAadhaarOtp = async () => {
    if (mobile.trim() === "") {
      setModalData("Please enter a valid Communication Mobile Number.");
      handleModalOpen();
      return false;
    }
    if (mobile.trim().length < 10) {
      setModalData("Please enter a valid Communication Mobile Number.");
      handleModalOpen();
      return false;
    }
    if (mobile.trim().match(/^[0-9]+$/) === null) {
      setModalData("Please enter a valid Communication Mobile Number.");
      handleModalOpen();
      return false;
    }
    if (aadhaarOtp.trim() === "") {
      setModalData("Please enter your OTP.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo = {
      otp: aadhaarOtp,
      mobile: mobile,
      txnId: txnId,
    };
    // debugger;
    const res = await asyncPost(
      URI.v3validateAadharOtp,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      //debugger;
      clearInterval(intervalId);
      setResendOtpChance(0);
      setTxnId(res.resObject.txnId);
      console.log("response Obj : " + JSON.stringify(res.resObject));
      if (res.resObject.isNew === "false") {
        setPatientName(
          res.resObject.ABHAProfile.firstName +
            " " +
            res.resObject.ABHAProfile.lastName
        );
        setIsNewProfile(res.resObject.isNew);
        setHealthIdRes(res.resObject.ABHAProfile.phrAddress[0]);
        setHealthIdNoRes(res.resObject.ABHAProfile.ABHANumber);
        setMobileRes(res.resObject.ABHAProfile.mobile);
        setKycPhotoRes(res.resObject.ABHAProfile.photo);
        setGenderRes(res.resObject.ABHAProfile.gender);
        //console.log(res.resObject.ABHAProfile.dob.replace(/-/g, "/"));
        setDobRes(res.resObject.ABHAProfile.dob.replace(/-/g, "/"));
        setXToken(res.resObject.tokens.token);
        setAddressRes(res.resObject.ABHAProfile.address);
        setDistrictCodeRes(res.resObject.ABHAProfile.districtCode);
        setStateCodeRes(res.resObject.ABHAProfile.stateCode);
        setPinCodeRes(res.resObject.ABHAProfile.pinCode);
        setModalData(res.responseMessage + res.resObject.message);
        setDistrictName(res.resObject.ABHAProfile.districtName || "");
        setStateName(res.resObject.ABHAProfile.stateName || "");
        handleModalOpen();
        {
          mobile === res.resObject.ABHAProfile.mobile
            ? setActiveStep(5)
            : handleNext();
        }
      } else if (res.resObject.isNew === "true") {
        setModalData(res.responseMessage + " & " + res.resObject.message);
        handleModalOpen();
        setIsNewProfile(res.resObject.isNew);
        setPatientName(
          res.resObject.ABHAProfile.firstName +
            " " +
            res.resObject.ABHAProfile.lastName
        );
        setHealthIdRes(res.resObject.ABHAProfile.phrAddress[0]);
        setHealthIdNoRes(res.resObject.ABHAProfile.ABHANumber);
        setMobileRes(res.resObject.ABHAProfile.mobile);
        setKycPhotoRes(res.resObject.ABHAProfile.photo);
        setGenderRes(res.resObject.ABHAProfile.gender);
        setDobRes(res.resObject.ABHAProfile.dob.replace(/-/g, "/"));
        setXToken(res.resObject.tokens.token);
        setAddressRes(res.resObject.ABHAProfile.address);
        setDistrictCodeRes(res.resObject.ABHAProfile.districtCode);
        setStateCodeRes(res.resObject.ABHAProfile.stateCode);
        setPinCodeRes(res.resObject.ABHAProfile.pinCode);
        setDistrictName(res.resObject.ABHAProfile.districtName || "");
        setStateName(res.resObject.ABHAProfile.stateName || "");
        {
          mobile === res.resObject.ABHAProfile.mobile
            ? // ? jumpStepToUpdateABHA()
              generateAbhaIdSuggestion()
            : handleNext();
        }
      } else {
        setModalData(res.responseMessage + " " + res.resObject.message);
        handleModalOpen();
        handleNext();
      }

      setShowLoader(false);
    } else {
      setShowLoader(false);
      setAadhaarOtp("");
      try {
        console.log("resObject : " + JSON.stringify(res.resObject));
        if (
          parseInt(res.statusCode) === 0 &&
          String(JSON.stringify(res.resObject.error)).includes("message")
        ) {
          setModalData(res.resObject.error.message);
          handleModalOpen(1);
          return false;
        } else if (
          parseInt(res.statusCode) === 0 &&
          String(JSON.stringify(res.resObject)).includes("otpValue")
        ) {
          setModalData(res.resObject.error.otpValue);
          handleModalOpen(1);
          return false;
        } else if (
          String(res.responseMessage).includes(
            "Failure: Could not send the OTP"
          )
        ) {
          setModalData(
            "Cannot validate OTP now. Please try again after sometime."
          );
          handleModalOpen(1);
          return false;
        }
      } catch (error) {
        setModalData("Invalid Aadhaar OTP value.");
        handleModalOpen(1);
        return false;
      }
    }
  };

  //To send OTP to user given mobile number for changing the registered mobile number.
  const getMobileOtp = async () => {
    clearInterval(intervalId);
    if (mobile.trim() === "") {
      setModalData("Please enter a valid Communication mobile number.");
      handleModalOpen();
      return false;
    }
    if (mobile.trim().match(/^[0-9]+$/) === null) {
      setModalData("Kindly enter a valid Communication Mobile Number.");
      handleModalOpen();
      return false;
    }
    const __oo = {
      mobile: mobile,
      txnId: txnId,
    };
    setShowLoader(true);
    const res = await asyncPost(
      URI.v3changeMobileNumber,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status == "Success") {
      setTxnId(res.resObject.txnId);
      setModalData(
        String(res.resObject.message).includes("OTP sent to mobile number")
          ? "OTP sent to the Communication Mobile Number ending with ******" +
              String(mobile).substring(6, 11)
          : res.resObject.message
      ); //
      handleModalOpen();
      resendOtpButtontext();
      handleNext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (res.resObject.hasOwnProperty("error")) {
        setModalData(res.resObject.error.message);
        handleModalOpen(1);
        return false;
      } else {
        setModalData("Cannot send OTP now. Try again after sometime.");
        handleModalOpen(1);
        return false;
      }
    }
  };
  //To resend OTP to the user given mobile number
  const resendMobileOtp = async () => {
    setShowLoader(true);
    //To show the remaining count as soon as the button is clicked.
    var count = parseInt(resendOtpChance);
    count++;
    setResendOtpChance(count);
    const __oo = {
      mobile: mobile,
      txnId: txnId,
    };
    setShowLoader(true);
    const res = await asyncPost(
      URI.v3changeMobileNumber,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status == "Success") {
      setTxnId(res.resObject.txnId);
      setModalData(
        String(res.resObject.message).includes("OTP sent to mobile number")
          ? "OTP sent to the Communication Mobile Number ending with ******" +
              String(mobile).substring(6, 11)
          : res.resObject.message
      ); //
      handleModalOpen();
      resendOtpButtontext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      setModalData(res.resObject.message);
      handleModalOpen(1);
    }
  };

  //To verify the OTP sent to the newly changed mobile number for ABHA profile
  const verifyMobileOtp = async () => {
    if (mobileOtp.trim() === "") {
      setModalData("Please enter an OTP to proceed.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo = {
      otpValue: mobileOtp,
      txnId: txnId,
    };
    const res = await asyncPost(
      URI.v3verifyMobileNumberOtp,
      __oo,
      true,
      true,
      global.token
    );
    if (
      res.status == "Success" &&
      res.resObject.hasOwnProperty("authResult") &&
      res.resObject.authResult !== "Failed"
    ) {
      //debugger;
      clearInterval(intervalId);
      setResendOtpChance(0);
      setTxnId(res.resObject.txnId);
      setShowLoader(false);
      setModalData(res.resObject.message);
      handleModalOpen();
      setMobileRes(mobile);
      isNewProfile === "true" ? generateAbhaIdSuggestion() : setActiveStep(5);
    } else {
      setShowLoader(false);
      setMobileOtp("");
      try {
        if (
          parseInt(res.statusCode) === 0 &&
          res.resObject.hasOwnProperty("error") &&
          res.resObject.error.hasOwnProperty("message")
        ) {
          setModalData(res.resObject.error.message);
          handleModalOpen(1);
          return false;
        }
        if (
          parseInt(res.statusCode) === 0 &&
          res.resObject.hasOwnProperty("otpValue")
        ) {
          setModalData(res.resObject.otpValue);
          handleModalOpen(1);
          return false;
        }
        if (
          res.resObject.hasOwnProperty("authResult") &&
          res.resObject.authResult === "Failed"
        ) {
          setModalData(res.resObject.message);
          handleModalOpen(1);
          return false;
        }
      } catch (error) {
        setModalData("Invalid OTP Value");
        handleModalOpen(1);
        return false;
      }
    }
  };

  //To get the Health Card of the verified profile
  const getHealthCard = async () => {
    setShowLoader(true);
    const __oo = {
      token: xToken,
    };
    // //debugger;
    const res = await asyncPost(
      URI.v3getHealthCard,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      //debugger;
      setProfileImageRes(res.resObject);
      handleNext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        parseInt(res.statusCode) === 0 &&
        String(JSON.stringify(res.resObject)).includes("message")
      ) {
        setModalData("Message from ABDM : " + res.resObject.message);
        handleModalOpen(1);
        return false;
      } else if (String(res.responseMessage).includes("Failure")) {
        setModalData(
          "Message from ABDM : Could not get ABHA card. Please try again after sometime."
        );
        handleModalOpen(1);
        return false;
      }
    }
  };
  const generateAbhaIdSuggestion = async () => {
    setShowLoader(true);
    const __oo = {
      txnId: txnId,
    };
    //debugger;
    const res = await asyncPost(
      URI.v3getHealthIdSuggestion,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      //debugger;
      console.log(res.resObject);
      setAbhaAddressList(res.resObject.abhaAddressList);
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        String(res.resObject.error.message) != null ||
        String(res.resObject.error.message) != ""
      ) {
        setModalData(res.resObject.error.message);
        handleModalOpen(1);
        return false;
      }
      if (String(res.resObject).includes("Unauthorized Access")) {
        setModalData("Server side error, cannot grant access.");
        handleModalOpen(1);
        return false;
      }
      if (String(res.resObject.error.code).includes("ABDM-1101")) {
        setModalData(res.resObject.error.message);
        handleModalOpen(1);
        return false;
      } else {
        setModalData(
          "Message from ABDM : Could not fetch the ABHA Address suggestions. Please try writing manually your ABHA Address."
        );
        handleModalOpen(1);
      }
    }
    setActiveStep(4);
  };

  const isInvalidAbhaAddress = (address) => {
    console.log(address);
    const trimmedAddress = address.trim();
    const dotCount = (trimmedAddress.match(/\./g) || []).length;
    const underscoreCount = (trimmedAddress.match(/_/g) || []).length;

    const startsWithAlphanumeric = /^[a-zA-Z0-9]/.test(trimmedAddress);
    const endsWithAlphanumeric = /[a-zA-Z0-9]$/.test(trimmedAddress);
    const containsOnlyAllowedChars = /^[a-zA-Z0-9._]*$/.test(trimmedAddress);
    const hasConsecutiveSpecialChars = /[._][._]/.test(trimmedAddress);

    // Improved return logic
    return (
      !startsWithAlphanumeric || // Must start with alphanumeric
      !endsWithAlphanumeric || // Must end with alphanumeric
      !containsOnlyAllowedChars || // Must only contain allowed chars
      dotCount > 1 || // Must not have more than one dot
      underscoreCount > 1 || // Must not have more than one underscore
      hasConsecutiveSpecialChars // Must not have consecutive special chars
    );
  };

  const saveNewAbhaId = async () => {
    debugger;
    const regex = "^[a-zA-Z0-9_.]*$";
    let hasValidationErrors = false;
    let validationNumbers = [];
    if (
      selectedAddress.trim().length < 8 &&
      selectedAddress.trim().length != 0
    ) {
      validationNumbers.push(1, 2);
      hasValidationErrors = true;
    }
    if (isInvalidAbhaAddress(selectedAddress)) {
      validationNumbers.push(3, 4, 5);
      hasValidationErrors = true;
    }
    if (!selectedAddress.trim().match(regex)) {
      validationNumbers.push(5);
      hasValidationErrors = true;
    }
    if (hasValidationErrors) {
      setModalData(
        <div>
          <div style={{ textAlign: "center" }}>
            <strong>Invalid ABHA Address:</strong> <br />
          </div>
          Validation rules for ABHA Address:
          <ol>
            <li
              style={{
                fontWeight: validationNumbers.includes(1) ? "bold" : "normal",
                color: validationNumbers.includes(1) ? "red" : "black",
              }}
            >
              Minimum length - 8 characters
            </li>
            <li
              style={{
                fontWeight: validationNumbers.includes(2) ? "bold" : "normal",
                color: validationNumbers.includes(2) ? "red" : "black",
              }}
            >
              Maximum length - 18 characters
            </li>
            <li
              style={{
                fontWeight: validationNumbers.includes(3) ? "bold" : "normal",
                color: validationNumbers.includes(3) ? "red" : "black",
              }}
            >
              Special characters allowed - 1 dot (.) and/or 1 underscore (_)
            </li>
            <li
              style={{
                fontWeight: validationNumbers.includes(4) ? "bold" : "normal",
                color: validationNumbers.includes(4) ? "red" : "black",
              }}
            >
              Special character dot and underscore should be in between. Special
              characters cannot be in the beginning or at the end
            </li>
            <li
              style={{
                fontWeight: validationNumbers.includes(5) ? "bold" : "normal",
                color: validationNumbers.includes(5) ? "red" : "black",
              }}
            >
              Alphanumeric - only numbers, only letters or any combination of
              numbers and letters is allowed
            </li>
          </ol>
        </div>
      );
      handleModalOpen();
      return false; // Exit the function early if there are validation errors
    }
    const atIndex = selectedAddress.indexOf("@");
    if (atIndex !== -1) {
      setSelectedAddress(selectedAddress.substring(0, atIndex));
    }
    setShowLoader(true);
    const __oo = {
      txnId: txnId,
      abhaAddress: selectedAddress,
      preferred: 1,
    };
    const res = await asyncPost(
      URI.v3saveNewHealthId,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      setShowLoader(false);
      console.log(res.resObject);
      setHealthIdRes(res.resObject.preferredAbhaAddress);
      setModalData("Your ABHA Address has been updated.");
      handleModalOpen();
      handleNext();
    } else {
      setShowLoader(false);
      if (res.status === "Failure" && res.resObject.hasOwnProperty("error")) {
        setModalData(res.resObject.error.message);
        handleModalOpen(1);
        return false;
      } else if (
        res.status === "Failure" &&
        res.resObject.hasOwnProperty("abhaAddress")
      ) {
        setModalData(res.resObject.abhaAddress);
        handleModalOpen(1);
        return false;
      } else if (res.status === "Failure") {
        setModalData(
          "Message from ABDM: Could not update ABHA address. Please try again after sometime."
        );
        handleModalOpen(1);
        return false;
      }
    }
  };

  //For downloading the card
  const downloadPng = async () => {
    window.location.href =
      "data:application/octet-stream;base64," + profileImageRes;
    var a = document.createElement("a"); //Create <a>
    a.href = "data:image/png;base64," + profileImageRes; //Image Base64 Goes here
    a.download = "NewAbhaHealthCard.png"; //File name Here
    a.click(); //Downloaded file
  };

  const CustomTooltipContent = () => {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Validation rules for ABHA Address:{" "}
            <ul style={{ listStyleType: "disc" }}>
              <li style={{ fontSize: "14px", margin: "7px" }}>
                Minimum length - 8 characters
              </li>
              <li style={{ fontSize: "14px", margin: "7px" }}>
                Maximum length - 18 characters
              </li>
              <li style={{ fontSize: "14px", margin: "7px" }}>
                Special characters allowed - 1 dot (.) and/or 1 underscore (_)
              </li>
              <li style={{ fontSize: "14px", margin: "7px" }}>
                Special character dot and underscore should be in between.
                Special characters cannot be in the beginning or at the end
              </li>
              <li style={{ fontSize: "14px", margin: "7px" }}>
                Alphanumeric - only numbers, only letters or any combination of
                numbers and letters is allowed.
              </li>
            </ul>
          </span>
        </Grid>
      </Grid>
    );
  };

  //To enable the Resend OTP button after a certain time {RESEND_OTP_TIMEOUT}
  const resendOtpButtontext = () => {
    let count = parseInt(resendOtpChance);
    let i = RESEND_OTP_TIMEOUT;
    if (i > 0 && count < RESEND_OTP_CHANCE) {
      const id = setInterval(() => {
        setButtonText("RESEND OTP AFTER: " + i + " sec");
        i = i - 1;
        if (i < 0) {
          count++;
          i = RESEND_OTP_TIMEOUT;
          setResendOtpChance(count.toString());
          count > RESEND_OTP_CHANCE
            ? setButtonText("CANNOT USE RESEND OTP")
            : setButtonText("RESEND OTP");
          clearInterval(id); // Clear interval using local variable
        }
      }, 1000);
      setIntervalId(id); // Save intervalId in state
    }
    if (count >= RESEND_OTP_CHANCE) {
      setButtonText("CANNOT USE RESEND OTP");
    }
  };

  const handleOtp = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setAadhaarOtp(value);
    } else {
      setAadhaarOtp((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };

  const handleMobileNumber = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setMobile(value);
    } else {
      setMobile((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };

  const handleMobileOtp = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setMobileOtp(value);
    } else {
      setMobileOtp((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    //debugger;
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    //((prevActiveStep) => prevActiveStep + 1) is a callback function that takes the previous state value of activeStep and returns the new state value by incrementing
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    if (activeStep === 1) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      clearInterval(intervalId);
      setResendOtpChance(0);
      setAadhaarOtp("");
      if (global.benificiaryName !== "")
        setBenificieryName(global.benificiaryName);
    }
    if (activeStep === 2) {
      setActiveStep(5);
    }
    if (activeStep === 3) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      clearInterval(intervalId);
      setResendOtpChance(0);
      mobileOtp("");
    }
    if (activeStep === 4) {
      setActiveStep(5);
    }
    if (activeStep === 5 || activeStep === 6) {
      setActiveStep(0);
      setActiveStep(0);
      resetHooks();
      if (global.benificiaryName !== "")
        setBenificieryName(global.benificiaryName);
    }
  };

  const handleModalOpen = (isError = 0) => {
    isError === 0 ? setModalError(0) : setModalError(1);
    setModalState(true);
  };
  const handleModalClose = () => {
    setModalState(false);
  };
  const changeMobileNumber = () => {
    // setMobile('');
    setActiveStep(2);
  };
  const postMessageToParent = async () => {
    const __oo = {
      name: patientName,
      healthId: healthIdRes,
      healthIdNumber: healthIdNoRes,
      gender: genderRes,
      mobile: mobileRes,
      dob: dobRes.includes("-") ? dobRes.replace(/-/g, "/") : dobRes,
      isNew: isNewProfile,
      yearOfBirth: dobRes
        .trim()
        .substring(dobRes.trim().length - 4, dobRes.trim().length),
      pngCard: profileImageRes,
      kycPhoto: kycPhotoRes,
      address: addressRes,
      districtCode: districtCodeRes,
      stateCode: stateCodeRes,
      pinCode: pinCodeRes,
      stateName: stateName,
      districtName: districtName,
      aadhaarNumber: aadhaarId,
    };
    console.log(__oo);
    window.parent.postMessage(JSON.stringify(__oo), "*");
  };

  //This Event is trigerred from the parent web UI.
  window.addEventListener("message", function (event) {
    if (event.data === "closeWindow") {
      postMessageToParent();
    }
  });

  const backToHome = async () => {
    postMessageToParent();
    setActiveStep(0);
    resetHooks();
  };

  const resetHooks = () => {
    if (global.aadhaarNo === null || global.aadhaarNo === "") {
      setAadhaarId("");
    }
    setAadhaarOtp("");
    if (global.mobileNumber === "" || global.mobileNumber === null) {
      setMobile("");
    }
    setTxnId("");
    setMobileOtp("");
    setResendOtpChance(0);
    clearInterval(intervalId);
  };

  const generateScreen = () => {
    if (activeStep == 0) {
      return populateScreenFlowOne(); // Get OTP for AADHAAR
    } else if (activeStep == 1) {
      return populateScreenFlowTwo(); // Verify OTP for AADHAAR
    } else if (activeStep == 2) {
      return populateScreenFlowThree(); // Update Registered mobile
    } else if (activeStep == 3) {
      return populateScreenFlowFour(); // validate mobile OTP
    } else if (activeStep == 4) {
      return populateScreenFlowFive(); //Change ABHA Address
    } else if (activeStep == 5) {
      return populateScreenFlowSix(); //display ABHA details
    } else if (activeStep == 6) {
      return populateScreenFlowSeven(); //display ABHA Card
    }
  };

  const populateScreenFlowOne = () => {
    return (
      <AadhaarInput handleOtp={handleGetOtp} getAadhaarId={setAadhaarId} />
    );
  };

  const populateScreenFlowTwo = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid
          container
          direction={"row"}
          spacing={1}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <item>
              <TextField
                variant="standard"
                label="Aadhaar OTP"
                inputProps={{ maxLength: 6 }}
                required
                id="aadhaarOtp"
                value={aadhaarOtp}
                type="text"
                autoComplete="off"
                onChange={(e) => handleOtp(e.target.value)}
              />
            </item>
          </Grid>
          <Grid item>
            <item>
              <TextField
                variant="standard"
                id="mobile"
                inputProps={{ maxLength: 10, style: { width: "230px" } }}
                required
                value={mobile}
                label="Communication Mobile Number"
                type="text"
                onChange={(e) => handleMobileNumber(e.target.value)}
                InputLabelProps={{
                  style: { marginTop: -14 }, // Adjust the negative margin value as needed
                }}
              />
            </item>
          </Grid>
          <Grid item>
            <item>
              <Button
                variant="contained"
                style={{
                  backgroundColor: global.secondaryColour,
                  color: "#fff",
                  paddingBottom: 10,
                  marginTop: 7,
                }}
                onClick={() => verifyAadhaarOtp()}
              >
                Verify & Proceed
              </Button>
            </item>
          </Grid>
          <Grid item>
            <item>
              <Button
                variant="contained"
                style={{
                  backgroundColor:
                    buttonText === "RESEND OTP" ? "#f53169d9" : "#ccc",
                  color: "#fff",
                  paddingBottom: 10,
                  marginTop: 7,
                }}
                onClick={() => resendAadhaarOtp()}
                disabled={buttonText === "RESEND OTP" ? false : true}
              >
                {buttonText}
              </Button>
            </item>
          </Grid>
          <Grid item>
            <item
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              {resendOtpChance === 3 ? (
                ""
              ) : (
                <span>
                  You can resend OTP{" "}
                  <span style={{ color: "#D20062" }}>
                    {resendOtpChance > 0
                      ? parseInt(RESEND_OTP_CHANCE) -
                        parseInt(resendOtpChance) +
                        1
                      : 2}
                  </span>{" "}
                  more times
                </span>
              )}
            </item>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowThree = () => {
    return (
      <form className={classes.form} noValidate>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h5
            style={{
              color: global.secondaryColour,
              marginBottom: "30px",
              fontWeight: "bold",
            }}
          >
            Communication Mobile Number Verification
          </h5>
        </div>
        <Grid
          container
          direction={"row"}
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <TextField
              variant="standard"
              id="mobile"
              value={mobile}
              label="Communication Mobile Number"
              type="text"
              onChange={(event) => handleMobileNumber(event.target.value)}
              inputProps={{ maxLength: 10, style: { width: "230px" } }}
              InputLabelProps={{
                style: { marginTop: -14 },
              }}
              required
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              style={{
                backgroundColor: global.secondaryColour,
                color: "#fff",
                paddingBottom: 10,
                marginTop: 7,
              }}
              onClick={() => getMobileOtp()}
            >
              Get OTP
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowFour = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid
          container
          direction={"row"}
          spacing={1}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <TextField
              variant="standard"
              required
              id="mobileOtp"
              inputProps={{ maxLength: 6, style: { width: "230px" } }}
              value={mobileOtp}
              label="Communication Mobile OTP"
              autoComplete="off"
              type="text"
              InputLabelProps={{
                style: { marginTop: -5 }, // Adjust the negative margin value as needed
              }}
              onChange={(e) => handleMobileOtp(e.target.value)}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              style={{
                backgroundColor: global.secondaryColour,
                color: "#fff",
                paddingBottom: 10,
                marginTop: 7,
              }}
              onClick={() => verifyMobileOtp()}
            >
              Verify & Proceed
            </Button>
          </Grid>
          <Grid item>
            <item>
              <Button
                variant="contained"
                style={{
                  backgroundColor:
                    buttonText === "RESEND OTP" ? "#f53169d9" : "#ccc",
                  color: "#fff",
                  paddingBottom: 10,
                  marginTop: 7,
                }}
                onClick={() => resendMobileOtp()}
                disabled={buttonText === "RESEND OTP" ? false : true}
              >
                {buttonText}
              </Button>
            </item>
          </Grid>
          <Grid item>
            <item
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              {resendOtpChance === 3 ? (
                ""
              ) : (
                <span>
                  You can resend OTP{" "}
                  <span style={{ color: "#D20062" }}>
                    {resendOtpChance > 0
                      ? parseInt(RESEND_OTP_CHANCE) -
                        parseInt(resendOtpChance) +
                        1
                      : 2}
                  </span>{" "}
                  more times
                </span>
              )}
            </item>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowFive = () => {
    return (
      <form className={classes.form} noValidate>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h5
            style={{
              color: global.secondaryColour,
              marginBottom: "30px",
              fontWeight: "bold",
            }}
          >
            Choose ABHA Address from Suggestions
          </h5>
        </div>

        <Grid
          container
          direction={"column"}
          spacing={5}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <InputLabel id="address-select-label">
              Select ABHA Address
            </InputLabel>
            <Select
              fullWidth
              labelId="address-select-label"
              id="address-select"
              value={selectedAddress}
              onChange={(event) => setSelectedAddress(event.target.value)}
              style={{ width: "300px" }}
            >
              <MenuItem value="" disabled>
                Choose the ABHA Address
              </MenuItem>
              {abhaAddressList.map((address) => (
                <MenuItem key={address} value={address}>
                  {address}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h6
              style={{
                color: "#2E4374",
                marginBottom: "20px",
                fontWeight: "bold",
              }}
            >
              or
            </h6>
          </div>
          <Grid
            item
            style={{
              marginLeft: "5%",
            }}
          >
            <TextField
              variant="standard"
              id="newHealthId"
              value={selectedAddress}
              label="Enter the ABHA Address"
              autoComplete="off"
              type="text"
              style={{ width: "300px" }}
              onChange={(e) => setSelectedAddress(e.target.value)}
            />
            <Tooltip title={<CustomTooltipContent />}>
              <Button>
                <InfoTwoTone />
              </Button>
            </Tooltip>
          </Grid>

          <Grid item>
            <Button
              variant="contained"
              style={{
                backgroundColor: global.secondaryColour,
                color: "#fff",
                paddingBottom: 10,
                marginTop: 7,
              }}
              onClick={() => saveNewAbhaId()}
            >
              Update ABHA Address
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowSix = () => {
    const kycPhotoI = "data:image/png;base64, " + kycPhotoRes;
    return (
      <Table size="big">
        <TableBody>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Number</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{healthIdNoRes}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Address</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {healthIdRes} <span>&nbsp;&nbsp;</span>
              {/* {isNewProfile == "yes" ? (
                <CreateTwoTone
                  style={{
                          backgroundColor: global.secondaryColour,
                          color: "#fff",
                        }}
                  onClick={() => generateAbhaIdSuggestion()}
                />
              ) : (
                ""
              )} */}
              <CreateTwoTone
                style={{
                  color: global.secondaryColour,
                }}
                onClick={() => generateAbhaIdSuggestion()}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Name</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{patientName}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Gender</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {genderRes == "M" ? "Male" : "Female"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Mobile</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {mobileRes} <span>&nbsp;&nbsp;</span>
              <CreateTwoTone
                style={{
                  color: global.secondaryColour,
                }}
                onClick={() => changeMobileNumber()}
              />
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Date of Birth</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{dobRes}</TableCell>
          </TableRow>
          {stateName !== null &&
          districtName !== null &&
          stateName.trim() != "" &&
          districtName.trim() != "" ? (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>State</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {stateName} <span>&nbsp;&nbsp;</span>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                <strong>District</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {districtName}
              </TableCell>
            </TableRow>
          ) : (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>State Code</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {stateCodeRes} <span>&nbsp;&nbsp;</span>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                <strong>District Code</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {districtCodeRes}
              </TableCell>
            </TableRow>
          )}
          {pinCodeRes !== null &&
          addressRes !== null &&
          addressRes.trim() !== "" &&
          pinCodeRes.trim() !== "" ? (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>Address</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {addressRes} <span>&nbsp;&nbsp;</span>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                <strong>Pincode</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>{pinCodeRes}</TableCell>
            </TableRow>
          ) : (
            ""
          )}
          <TableRow>
            <TableCell colSpan={4} className="imgcontainer">
              <div className="text-center">
                <img src={kycPhotoI} />
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4} style={{ textAlign: "center" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "##E5E4E2",
                  color: "#f53169d9",
                  width: "200px",
                }}
                onClick={() => getHealthCard()}
              >
                View ABHA Card
              </Button>
              <Button
                variant="contained"
                className="mx-2"
                style={{
                  backgroundColor: "#f53169d9",
                  color: "#fff",
                }}
                onClick={() => backToHome()}
              >
                Save and Continue
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  };

  const populateScreenFlowSeven = () => {
    const profileImageI = "data:image/png;base64, " + profileImageRes;
    return (
      <div className="text-center">
        <img src={profileImageI} width={"80%"} />

        <div style={{ textAlign: "center" }} className="my-2">
          <Button
            variant="contained"
            className="mx-2"
            style={{
              backgroundColor: "##E5E4E2",
              color: "#f53169d9",
              width: "200px",
            }}
            onClick={() => downloadPng()}
          >
            Download ABHA Card
          </Button>
          <Button
            variant="contained"
            className="mx-2"
            style={{
              backgroundColor: "#f53169d9",
              color: "#fff",
            }}
            onClick={() => backToHome()}
          >
            Save and Continue
          </Button>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Paper className={classes.paper} style={{ padding: "10px" }}>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {/* {generateScreen()} */}
            {showLoader ? (
              <div style={{ textAlign: "center", marginTop: 60 }}>
                <CircularProgress style={{ color: global.secondaryColour }} />
                <h5 style={{ marginTop: 5 }}>Loading...</h5>
              </div>
            ) : (
              generateScreen()
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                pt: 2,
                marginRight: 20,
              }}
            >
              <Button
                style={
                  activeStep === 0 ? { color: "#ccc" } : { color: "#f53169d9" }
                }
                onClick={() => handleBack()}
                sx={{ mr: 1 }}
                disabled={activeStep === 0 ? true : false}
              >
                {" "}
                Back
              </Button>
            </Box>
          </React.Fragment>
        )}
      </Paper>
      <Modal
        open={modalState}
        onClose={handleModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        BackdropProps={{ timeout: 500 }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Fade in={modalState}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // Ensures full viewport height for centering
            }}
          >
            <Box
              sx={{
                background: "white",
                display: "flex",
                flexDirection: "column",
                borderRadius: 2,
                p: 3,
                minWidth: "300px",
                maxWidth: "80vw",
                width: modalWidth,
                boxShadow: 24,
              }}
            >
              {modalError === 1 ? (
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 50 50"
                    className="me-2"
                    width="25px"
                    height="27px"
                    fill="#000000"
                  >
                    <circle
                      style={{ fill: "#D75A4A" }}
                      cx="25"
                      cy="25"
                      r="25"
                    />
                    <polyline
                      style={{
                        fill: "none",
                        stroke: "#FFFFFF",
                        strokeWidth: 2,
                        strokeLinecap: "round",
                        strokeMiterlimit: 10,
                      }}
                      points="16,34 25,25 34,16"
                    />
                    <polyline
                      style={{
                        fill: "none",
                        stroke: "#FFFFFF",
                        strokeWidth: 2,
                        strokeLinecap: "round",
                        strokeMiterlimit: 10,
                      }}
                      points="16,16 25,25 34,34"
                    />
                  </svg>
                  <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                    Error
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <svg
                    width="25"
                    height="27"
                    viewBox="0 0 128 128"
                    className="me-2"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <style>
                        {`.cls-1{fill:#ffe082}
                        .cls-2{fill:#404040}
                        .cls-3{fill:#9e9e9e}
                        .cls-4{fill:#f5f5f5}`}
                      </style>
                    </defs>
                    <path
                      className="cls-1"
                      d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                    />
                    <path
                      className="cls-2"
                      d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                    />
                    <path
                      className="cls-3"
                      d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                    />
                    <path
                      className="cls-2"
                      d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="102" y2="98" />
                    <path
                      className="cls-2"
                      d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="110" y2="106" />
                    <path
                      className="cls-2"
                      d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                  </svg>
                  <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                    Information
                  </Typography>
                </Box>
              )}
              {/* Decorative Lines */}
              <Divider sx={{ width: "50%", mb: 0.5 }} />
              <Divider sx={{ width: "40%", mb: 2 }} />
              <Typography
                variant="body1"
                sx={{ whiteSpace: "pre-wrap", mb: 2 }}
              >
                {modalData}
              </Typography>
              <Button
                variant="contained"
                style={{
                  backgroundColor: global.secondaryColour,
                  color: "#fff",
                  paddingBottom: 10,
                  marginTop: 7,
                }}
                onClick={handleModalClose}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}

export default GenerateAbhaV3;
